module.exports = __webpack_public_path__ + "r-v3/img/ml_41_01.d3a27ef4.jpg";